import { render, staticRenderFns } from "./PagedItems.vue?vue&type=template&id=de00f8ac&"
import script from "./PagedItems.vue?vue&type=script&lang=js&"
export * from "./PagedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports